export enum StandLayoutEnum {
  'complete' = 0,
  'compact' = 1,
  'admin' = 2,
  'detailsPage' = 3,
  'standFree' = 4
}
